import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';

const WorkspaceDetailSkeleton = () => {
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <header className="bg-neutral-50 text-neutral-900 sticky top-0 z-10 border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2 sm:py-4">
          <div className="flex justify-between items-center">
            <button className="text-neutral-600 p-2">
              <FaArrowLeft className="w-5 h-5" />
            </button>
            <div className="h-8 w-48 bg-neutral-200 rounded-lg animate-pulse"></div>
            <div className="w-20 h-8 bg-neutral-200 rounded-lg animate-pulse"></div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-3 sm:px-4 py-3 sm:py-6 max-w-6xl">
        {/* Stats Skeleton */}
        <div className="mb-4">
          <div className="flex items-center justify-center gap-12 py-4">
            {[1, 2, 3].map((i) => (
              <React.Fragment key={i}>
                {i !== 1 && <div className="w-px h-8 bg-neutral-200" />}
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-neutral-200 animate-pulse"></div>
                  <div className="flex flex-col gap-2">
                    <div className="w-24 h-4 bg-neutral-200 rounded animate-pulse"></div>
                    <div className="w-16 h-6 bg-neutral-200 rounded animate-pulse"></div>
                  </div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Search Bar Skeleton */}
        <div className="mb-6">
          <div className="relative w-full max-w-2xl mx-auto">
            <div className="w-full h-12 bg-neutral-200 rounded-xl animate-pulse"></div>
          </div>
        </div>

        {/* Tabs Skeleton */}
        <div className="flex justify-center space-x-4 mb-6">
          {[1, 2].map((i) => (
            <div key={i} className="w-24 h-10 bg-neutral-200 rounded-xl animate-pulse"></div>
          ))}
        </div>

        {/* Filter Pills Skeleton */}
        <div className="mb-6 overflow-hidden">
          <div className="flex gap-2 overflow-x-auto pb-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="w-32 h-8 bg-neutral-200 rounded-xl animate-pulse shrink-0"></div>
            ))}
          </div>
        </div>

        {/* Content Grid Skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="bg-white rounded-xl p-4 border-2 border-neutral-200">
              <div className="w-3/4 h-6 bg-neutral-200 rounded mb-4 animate-pulse"></div>
              <div className="space-y-2">
                <div className="w-full h-4 bg-neutral-200 rounded animate-pulse"></div>
                <div className="w-2/3 h-4 bg-neutral-200 rounded animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkspaceDetailSkeleton; 